import Actions from 'redux/actions'
import type { CallAPIAction, Status } from 'api/types'

type State = {} & Status

const initialState = {
  isLoading: false,
  success: false,
  fail: false,
}

export default (
  state: State = initialState,
  action: CallAPIAction<
    Actions.SEND_UPDATE_PASSWORD_OTP_ASYNC,
    Actions.SEND_UPDATE_PASSWORD_OTP_SUCCESS,
    Actions.SEND_UPDATE_PASSWORD_OTP_FAIL
  >,
): State => {
  switch (action.type) {
    case Actions.SEND_UPDATE_PASSWORD_OTP_ASYNC:
    case Actions.SEND_UPDATE_PASSWORD_OTP_SUCCESS:
    case Actions.SEND_UPDATE_PASSWORD_OTP_FAIL: {
      return {
        ...state,
        ...action.status,
      }
    }
    default:
      return state
  }
}
